import { TransferRevisionRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateReviseTransferDetailsLoan = (allowTransferDateAnyDayOfMonth: boolean) =>
  makeValidator({
    FieldParser: TransferRevisionRow(allowTransferDateAnyDayOfMonth),
  });
